<template>
  <div class="home-footer">
    <div class="home-footer-inside">
      <div class="left">
        <div class="title">
          <span class="zh">永辉自有品牌</span>
          <span class="en">/YH Brand</span>
        </div>
        <div class="content">
          <div
            v-for="(item,i) in brandLogo"
            :key="i"
          >
            <img
              :src="require(`@/assets/index/brand/${item}.png`)"
              class="brand-logo"
              @click="onBrandClick(item)"
            >
          </div>
        </div>
      </div>
      <div class="right">
        <div class="title">
          <span class="zh">联系我们</span>
          <span class="en">/Contact us</span>
        </div>
        <div class="content">
          <div
            class="error-correction"
            @click="onErrorCorrection"
          >
            <img
              src="@/assets/index/纠错.png"
              alt
            >
            <div>我要纠错</div>
            <img
              src="@/assets/index/箭头5.png"
              alt
            >
          </div>
          <div
            class="feedback"
            @click="onFeedback"
          >
            <img
              src="@/assets/index/反馈.png"
              alt
            >
            <div>产品反馈</div>
            <img
              src="@/assets/index/箭头5.png"
              alt
            >
          </div>
        </div>
        <div
          v-show="dialogShow"
          class="feedback-dialog"
        >
          <div
            v-if="!success"
            class="body"
          >
            <div class="title">
              {{ title }}
            </div>
            <textarea
              v-model="content"
              :placeholder="placeholder"
            />
            <div>
              <button
                :class="content.length > 0 ? 'active' : ''"
                @click="send"
              >
                发送
              </button>
            </div>
          </div>
          <div
            v-else
            class="success"
          >
            <img src="@/assets/index/反馈成功.png">
            <div class="title">
              反馈成功！
            </div>
            <div class="content">
              非常感谢您的反馈，美好的用户体验离不开您的宝贵建议！
            </div>
          </div>
          <div
            class="close"
            @click="dialogShow = false; success = false"
          >
            <img src="@/assets/index/叉.png">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomeFooter',
  data() {
    return {
      title: '您的反馈帮助我们更加完善！',
      type: '产品反馈',
      placeholder: '请输入您的反馈信息',
      dialogShow: false,
      content: '',
      success: false,
      brandLogo: [1, 2, 3, 4, 5, 6]
    }
  },
  methods: {
    onErrorCorrection() {
      this.type = '我要纠错'
      this.title = '您的纠错帮助我们更加完善!'
      this.placeholder = '请输入您的纠错信息'
      this.dialogShow = true
      this.success = false
      this.content = ''

      this.ajax.doPost({
        packageName: 'user',
        className: 'userAnalysis',
        methodName: 'create',
        params: {
          userId: this.$store.state.sys.sysUser.me.id,
          moduleName: '联系我们-纠错',
          moduleResourceId: this.$route.params.id,
          path: this.$route.path
        }
      })
    },
    onFeedback() {
      this.type = '产品反馈'
      this.title = '您的反馈帮助我们更加完善!'
      this.placeholder = '请输入您的反馈信息'
      this.dialogShow = true
      this.success = false
      this.content = ''

      this.ajax.doPost({
        packageName: 'user',
        className: 'userAnalysis',
        methodName: 'create',
        params: {
          userId: this.$store.state.sys.sysUser.me.id,
          moduleName: '联系我们-反馈',
          moduleResourceId: this.$route.params.id,
          path: this.$route.path
        }
      })
    },
    onBrandClick(e) {
      this.ajax.doPost({
        packageName: 'user',
        className: 'userAnalysis',
        methodName: 'create',
        params: {
          userId: this.$store.state.sys.sysUser.me.id,
          moduleName: '品类品牌',
          moduleResourceId: e,
          path: this.$route.path
        }
      })
    },
    async send() {
      if (this.content) {
        const result = await this.ajax.doPost({
          packageName: 'user',
          className: 'feedback',
          methodName: 'create',
          params: {
            userId: this.$store.state.sys.sysUser.me.id,
            type: this.type,
            content: this.content,
            processStatus: '未处理'
          }
        })

        this.success = true
      } else {
        this.$message({
          type: 'error',
          message: '请输入内容！',
          duration: 5000
        })
      }
    }
  }
}
</script>

<style lang="less" scoped>
.home-footer {
  background: rgba(245, 245, 245, 1);
  .home-footer-inside {
    width: 1100px;
    margin: 0 auto;
    padding: 40px 0;
  }
  .title {
    .zh {
      font-size: 28px;
      font-family: "FZQKBYSJW";
      font-weight: normal;
      color: rgba(51, 51, 51, 1);
      line-height: 31px;

      margin-right: 20px;
    }

    .en {
      font-size: 14px;
      font-weight: 200;
      color: rgba(132, 135, 145, 1);
      line-height: 20px;
    }
  }
  .left {
    display: inline-block;
    width: 560px;
    margin-right: 80px;
    vertical-align: top;

    .content {
      margin-top: 40px;

      div {
        width: 120px;
        margin: 0 20px 20px 0;
        display: inline-block;
        cursor: pointer;

        img {
          width: 100%;
        }
        .brand-logo{
          display: block;
          width: 100px;
          height:100px;
        }
      }
    }
  }
  .right {
    display: inline-block;
    width: 460px;
    vertical-align: top;

    // position: absolute;

    // background: rgba(245, 245, 245, 1);

    .content {
      //   position: relative;

      margin-top: 40px;
      .error-correction,
      .feedback {
        width: 265px;
        height: 80px;
        background: rgba(255, 255, 255, 1);
        margin: 30px 0;
        cursor: pointer;

        img:first-child {
          display: inline-block;
          height: 40px;
          margin: 20px 40px;
          vertical-align: top;
        }

        div {
          display: inline-block;
          font-size: 16px;
          font-weight: 500;
          color: rgba(51, 51, 51, 1);
          line-height: 40px;

          margin: 20px 0;
          vertical-align: top;
        }

        img:last-child {
          display: inline-block;
          height: 16px;
          margin: 32px 30px;
          vertical-align: top;
        }
      }
    }
    .feedback-dialog {
      width: 280px;
      height: 0;
      position: relative;
      top: -310px;
      left: 300px;
      .body {
        width: 280px;
        height: 280px;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 9px 18px 0px rgba(0, 0, 0, 0.06);

        .title {
          font-size: 16px;
          font-weight: 600;
          color: rgba(51, 51, 51, 1);
          line-height: 62px;
          height: 62px;
          margin-left: 18px;
        }

        textarea {
          width: 244px;
          height: 114px;
          background: rgba(245, 245, 245, 1);

          border: 0;
          outline: 0;

          padding: 18px;
          font-size: 12px;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          line-height: 17px;
          resize: none;
        }

        textarea::placeholder {
          font-size: 12px;
          font-weight: 400;
          color: rgba(191, 191, 191, 1);
          line-height: 17px;
        }

        button {
          width: 85px;
          height: 38px;
          background: rgba(191, 191, 191, 1);

          cursor: pointer;

          border: 0;
          outline: 0;

          font-size: 14px;
          font-weight: 500;
          color: rgba(255, 255, 255, 1);
          line-height: 20px;

          float: right;
          margin: 12px 18px 0 0;
        }

        button.active {
          color: white;
          background: rgba(64, 177, 93, 1);
        }
      }

      .success {
        width: 280px;
        height: 280px;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 9px 18px 0px rgba(0, 0, 0, 0.06);
        text-align: center;
        img {
          width: 50px;
          height: 50px;

          margin-top: 75px;
        }

        .title {
          font-size: 20px;
          font-weight: 600;
          color: rgba(51, 51, 51, 1);
          line-height: 28px;
          margin: 10px;
        }

        .content {
          margin: 18px;
          font-size: 12px;

          font-weight: 200;
          color: rgba(51, 51, 51, 1);
          line-height: 17px;
        }
      }

      .close {
        width: 38px;
        height: 38px;
        background: rgba(227, 50, 71, 1);
        box-shadow: 0px 9px 18px 0px rgba(0, 0, 0, 0.06);

        text-align: center;
        line-height: 38px;

        float: right;
        margin-top: 20px;

        cursor: pointer;
        img {
          width: 13px;
        }
      }
    }
  }
}
</style>
